import {
  LineItemsDtoCategoryEnum,
  LineItemsDtoNameEnum,
} from '@b-stock/order-api-client'

type FeeLineItem = {
  category?: string
  name?: string
  amount?: number
}

/**
 * What the buyer owes B-Stock on a Seller Collects order, in cents.
 *
 * Read from the buyer's premium line item, never from `totalAmount`. The order
 * total was used until QA found freight on it: a GE order with no buyer
 * premium read as a $105 B-Stock fee, because Standard Shipping freight lands
 * on the same total. B-Stock collects only its fee on these orders, so the
 * total is the fee *only* when nothing else happens to be there.
 *
 * `BUYERS_PREMIUM` is the one name the line-item builder emits for this
 * (`be/order/src/line-item-builder/line-item-builder.data.ts`), destined for
 * B-Stock. `BUYERS_PREMIUM_REBATE` is excluded deliberately — it flows from
 * B-Stock to the seller and is not a buyer charge.
 */
export const getSellerCollectsBstockFeeCents = (
  lineItems: FeeLineItem[] | undefined
): number =>
  (lineItems ?? [])
    .filter(
      (item) =>
        item.category === LineItemsDtoCategoryEnum.Fee &&
        item.name === LineItemsDtoNameEnum.BuyersPremium
    )
    .reduce((sum, item) => sum + (item.amount ?? 0), 0)
